module.exports = __webpack_public_path__ + "static/media/setting.9d314c41.svg";